<template>
  <div class="container">
    <div class="container__inner container__inner--min exhibition">
      <h2 class="contentTitle contentTitle--center">函館展</h2>
    </div>
    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">アクセス</p>
      <div class="exhibition__cont">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2974.5567637045324!2d140.75186301515095!3d41.79476507860457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f9ef46bb53c0eb3%3A0x75f5f82028f1a89e!2z5LqU56ic6YOt44K_44Ov44O8!5e0!3m2!1sja!2sjp!4v1549686657674"
          width="640"
          height="320"
          frameborder="0"
          allowfullscreen
          class="exhibition__cont__map"
        ></iframe>
      </div>
      <ul class="exhibition__cont detailTable">
        <li class="detailTable__item">
          <p class="detailTable__item__title">住所</p>
          <p class="detailTable__item__cont">〒040-0001 北海道函館市五稜郭町43-9</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">公式HP</p>
          <p class="detailTable__item__cont">
            <a
              href="http://www.goryokaku-tower.co.jp/"
              target="_blank"
              rel="noopener noreferrer"
            >goryokaku-tower.co.jp/</a>
          </p>
        </li>
      </ul>
      <div class="exhibition__cont exhibition__cont--center">
        <a
          class="subButton"
          href="https://www.goryokaku-tower.co.jp/access"
          target="_blank"
          rel="noopener noreferrer"
        >会場への行き方を見る</a>
      </div>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">開催概要</p>
      <ul class="exhibition__cont detailTable">
        <li class="detailTable__item">
          <p class="detailTable__item__title">日程</p>
          <p class="detailTable__item__cont">2019年2月10(日) 〜 11日(月)</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">場所</p>
          <p class="detailTable__item__cont">五稜郭タワー 1F アトリウム</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">時間</p>
          <p class="detailTable__item__cont">10:00 〜 16:00</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">主催</p>
          <p class="detailTable__item__cont">公立はこだて未来大学 情報デザインコース</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">共催</p>
          <p class="detailTable__item__cont">五稜郭タワー株式会社</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">協力</p>
          <p class="detailTable__item__cont">学術連携室 / 社会連携センター</p>
        </li>
      </ul>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">タイムテーブル</p>
      <ul class="exhibition__cont timeTable">
        <li class="timeTable__item">
          <p class="timeTable__item__title">10:00</p>
          <p class="timeTable__item__cont">開場</p>
        </li>
        <li class="timeTable__item">
          <div class="timeTable__item__title">
            <div class="timeTable__item__title__box">
              <p>11:00</p>
              <span class="heightBorder"></span>
              <p>12:00</p>
            </div>
            <div class="timeTable__item__title__box">
              <p>14:00</p>
              <span class="heightBorder"></span>
              <p>15:00</p>
            </div>
          </div>
          <p class="timeTable__item__cont">ポスターセッション</p>
        </li>
        <li class="timeTable__item">
          <p class="timeTable__item__title">16:00</p>
          <p class="timeTable__item__cont">閉場</p>
        </li>
      </ul>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">展示内容</p>
      <div class="exhibition__cont">
        <img src="../../../assets/Hakodate/pamphlet.svg" alt>
      </div>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">函館展は終了致しました！</p>
      <div class="exhibition__cont">
        <img src="../../../assets/Hakodate/photo01.jpg" alt>
        <img src="../../../assets/Hakodate/photo02.jpg" alt>
        <img src="../../../assets/Hakodate/photo03.jpg" alt>
        <img src="../../../assets/Hakodate/photo04.jpg" alt>
        <img src="../../../assets/Hakodate/photo05.jpg" alt>
        <img src="../../../assets/Hakodate/photo06.jpg" alt>
        <img src="../../../assets/Hakodate/photo07.jpg" alt>
        <img src="../../../assets/Hakodate/photo08.jpg" alt>
        <img src="../../../assets/Hakodate/photo09.jpg" alt>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'o-exibitions'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$white: #fff;
$yellow: #eddb44;
$thin-yellow: #f2e680;
$blue: #009898;

.container {
  margin-top: calc(72px + 80px);
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
    margin-top: calc(32px + 56px);
  }
  @media screen and (max-width: 411px) {
    margin-top: calc(32px + 40px);
  }
}

.timeTable {
  width: 100%;
  padding: 16px;
  line-height: 1.5;
  background: $yellow;
  color: $blue;
  font-size: 18px;
  font-weight: 700;
  &__item {
    display: flex;
    &:not(:last-child) {
      margin-bottom: 16px;
    }
    &__title {
      letter-spacing: 1.5px;
      &__box {
        background: $thin-yellow;
        padding: 16px 24px;
        &:not(:last-child) {
          margin-bottom: 16px;
        }
      }
    }
    &:not(:nth-child(2)) > .timeTable__item__title {
      background: $thin-yellow;
      padding: 16px 24px;
    }
    &__cont {
      display: flex;
      align-items: center;
      justify-content: center;
      background: $thin-yellow;
      padding: 16px;
      margin-left: 8px;
      width: 100%;
    }
  }
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
  }
  @media screen and (max-width: 411px) {
    font-size: 16px;
    padding: 8px;
    &__item {
      display: flex;
      &:not(:last-child) {
        margin-bottom: 8px;
      }
      &__title {
        &__box {
          padding: 8px 16px;
          &:first-child {
            margin-bottom: 8px;
          }
        }
      }
      &:not(:nth-child(2)) > .timeTable__item__title {
        padding: 8px 16px;
      }
      &__cont {
        padding: 8px;
        margin-left: 4px;
      }
    }
  }
}

.heightBorder {
  background: $blue;
  border-radius: 4px;
  content: "";
  display: flex;
  margin: 4px auto;
  width: 3px;
  height: 12px;
  @media screen and (max-width: 411px) {
    width: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/Hakodate/index.vue